import React, { memo } from 'react';
import { InverseScaleBox } from './InverseScaleBox';

interface MediaDimensionsProps {
  width: number;
  height: number;
}

/**
 * 媒体尺寸显示组件 — 显示在节点卡片右上角，与标题水平中心对齐
 * 参考标题的字体大小（14px）和缩放规则（InverseScaleBox + minZoom=0.7）
 * 独立容器，不与标题写在一起
 */
export const MediaDimensions = memo(({ width, height }: MediaDimensionsProps) => {
  return (
    <InverseScaleBox
      minZoom={0.5}
      className="absolute right-0 z-10"
      style={{ bottom: '100%', paddingBottom: '4px' }}
      scaleOrigin="bottom right"
    >
      <div
        className="flex items-center justify-end pointer-events-none"
        style={{ height: '25px', transform: 'translate(0px, -4px)' }}
      >
        <span className="text-[14px] font-medium text-white tabular-nums whitespace-nowrap">
          {width}×{height}
        </span>
      </div>
    </InverseScaleBox>
  );
});

MediaDimensions.displayName = 'MediaDimensions';
